var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 195,
    viewBox: "0 0 195 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 0C43.6465 0 0 43.6465 0 97.5C0 151.354 43.6465 195 97.5 195C151.354 195 195 151.354 195 97.5C195 43.6465 151.354 0 97.5 0ZM70.2305 138.29H51.2256V77.4668H70.2305V138.29ZM60.2139 69.8496H60.0615C53.168 69.8496 48.7119 65.2031 48.7119 59.2998C48.7119 53.2822 53.3203 48.75 60.3281 48.75C67.3359 48.75 71.6396 53.2822 71.792 59.2998C71.8301 65.165 67.374 69.8496 60.2139 69.8496ZM146.25 138.29H124.693V106.831C124.693 98.6045 121.342 92.9678 113.915 92.9678C108.24 92.9678 105.079 96.7764 103.632 100.433C103.099 101.728 103.175 103.556 103.175 105.422V138.29H81.8086C81.8086 138.29 82.0752 82.5322 81.8086 77.4668H103.175V87.0264C104.432 82.8369 111.249 76.8955 122.142 76.8955C135.662 76.8955 146.25 85.6553 146.25 104.47V138.29Z",
    fill: "#7768EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1be0de581494e72788c346428812816d.svg";
export { ForwardRef as ReactComponent };